// FDI (11-48) -> quadrant-local digit (1-8), as printed on the Billing PDF.
export const fdiToPalmer = (fdiNum) => parseInt(fdiNum) % 10;

// Right-hand quadrants (S1 upper right, S3 lower right) read 8 -> 1 toward the midline.
// `separator` defaults to ', ' so the job cards, daily report and sales reports that also
// call this are unaffected; the Billing statement passes a plain space because its Tooth
// column is narrow and a full quadrant has to stay on one line.
export const palmerDesc = (section, separator = ', ') =>
    Array.isArray(section) && section.length > 0
        ? section.map(fdiToPalmer).sort((a, b) => b - a).join(separator)
        : null;

// Left-hand quadrants (S2 upper left, S4 lower left) read 1 -> 8 away from the midline.
export const palmerAsc = (section, separator = ', ') =>
    Array.isArray(section) && section.length > 0
        ? section.map(fdiToPalmer).sort((a, b) => a - b).join(separator)
        : null;

// Total selected units across all four quadrants.
export const unitCount = (sections) =>
    ['S1', 'S2', 'S3', 'S4'].reduce(
        (sum, key) => sum + (Array.isArray(sections && sections[key]) ? sections[key].length : 0), 0);

// Every FDI number selected anywhere on an order, as a Set of ints.
// palmerDesc/palmerAsc return joined strings, which answer "which teeth, listed"; a chart needs
// the opposite question - "is tooth N selected" - so it needs membership instead.
// Unions across ALL line items on purpose: one label covers the whole case, not one line item.
// Values arrive from the API as strings, so they are parsed before being added.
export const fdiSelectedSet = (lineItems) => {
    const selected = new Set();
    (Array.isArray(lineItems) ? lineItems : []).forEach((item) => {
        ['S1', 'S2', 'S3', 'S4'].forEach((key) => {
            const quadrant = item && item.sections && item.sections[key];
            if (Array.isArray(quadrant)) {
                quadrant.forEach((fdi) => {
                    const num = parseInt(fdi);
                    if (!isNaN(num)) selected.add(num);
                });
            }
        });
    });
    return selected;
};
